import { map, filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';
import { ConfigService } from './services/config.service';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from './services/login.service';
import { BrowserUtils } from '@azure/msal-browser';
import { User } from './models/identity';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  isAdminRoute: boolean;
  isIframe: boolean;
  currentUser: User;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private languageService: LanguageService,
    private cookieService: CookieService,
    private configService: ConfigService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.isIframe = BrowserUtils.isInIframe() && !window.opener; 
    this.loginService.employeeLoggedIn.subscribe(c => this.setCurrent());
    this.setCurrent();
    this.initApplicationLanguage(
      this.cookieService.get(
        this.configService.configData.cookieLanguageNameKey
      )
    );
    this.getIsAdminRoute().subscribe((x) => {
      this.isAdminRoute = x;
    });
  }

  private getIsAdminRoute(): Observable<boolean> {
    return this.router.events.pipe(
      filter((e) => e['url'] !== undefined),
      map((r) => r['url'].includes('admin'))
    );
  }

  private initApplicationLanguage(language: string) {
    if (language) {
      this.setLanguage(language);
    } else {
      this.languageService
        .getDefaultLanguage()
        .subscribe((data) => this.setLanguage(data.code.toLowerCase()));
    }
  }

  private setLanguage(language: string) {
    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }

  private setCurrent() {
    this.currentUser = this.loginService.getCurrent();
  }
}
